export default __webpack_public_path__ + "static/media/sponsor-easycomp.c2b8268a.png";